export default "__VITE_ASSET__830e191e__"